export default __webpack_public_path__ + "static/hero-img-f099f67c406818a68eb6318faa794e7a.svg";